import ContactInfo from './FooterContactInfo/FooterContactInfo.vue';

new Vue({
    el: "#ContactInfo",
    components: {
        "contact-info": ContactInfo
    }  
});


// WEBPACK FOOTER //
// ./Scripts/app/Footer.js